import './survey_item_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CSATChartView extends Monitoring.Views.Charts.SurveyItemChartView
  className: 'processing item'
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  csatTemplate: JST['backbone/templates/monitoring/charts/csat_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @facets = @options.facets
    @_settings = @options.settings
    @title = @_settings.name
    @terms = @_itemTerms(@facets.cem_surveys[0], @_settings.code)
    @minScore = 1
    @maxScore = 5

  render: ->
    @$el.html @template
      title: @title
    @trigger('masonry')
    @

  afterAppend: ->
    @$el.removeClass('processing')

    @$el.find('.chart').html @csatTemplate

    satisfactoryAnswers = 0
    totalAnswers = 0
    _.each(@terms, (term) ->
      if term.term >= 4
        satisfactoryAnswers = satisfactoryAnswers + term.count
      totalAnswers = totalAnswers + term.count
    )
    csat = (satisfactoryAnswers / totalAnswers) * 100
    roundedCsat = Math.round(csat * 100) / 100

    chart = new Highcharts.Chart
      chart:
        renderTo: @$el.find('.csat-chart')[0]
        type: 'solidgauge'
      title:
        text: @_settings.actual_name
      exporting:
        enabled: false
      pane:
        center: ['50%', '50%']
        size: '100%'
        startAngle: -90
        endAngle: 90
        background:
          innerRadius: '60%'
          outerRadius: '100%'
          shape: 'arc'
      yAxis:
        min: 0
        max: 100
        lineWidth: 0
        tickWidth: 0
        labels:
          enabled: false
      plotOptions:
        solidgauge:
          dataLabels:
            enabled: true
            format: '<span style="font-size:36px">{y}%</span>'
      series: [
        name: 'CSAT'
        data: [roundedCsat]
      ]
